import { Component } from '@angular/core';
import { Icons } from '@core/constants/icons';
import { Permissions } from '@core/constants/permissions';
import { SessionInfo } from '@core/objects/session-info';
import { SessionService } from '@core/services/session.service';

import { AuthenticationService } from './core/services/authentication.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent {
  title = 'central';

  sessionInfo: SessionInfo = {
    user: null,
    roles: [],
  };

  icons: typeof Icons = Icons;
  permissions: typeof Permissions = Permissions;

  constructor(
    sessionService: SessionService,
    private authenticationService: AuthenticationService,
  ) {
    sessionService.sessionInfo$.subscribe(value => {
      this.sessionInfo = value;
    });
  }

  logout(): void {
    this.authenticationService.logout();
  }
}
